import {
  BATTLE_UI_EMOTE_BUTTON_PATH,
  BATTLE_UI_EMOTE_NEGATIVE_BUTTON_PATH,
  BATTLE_UI_EMOTE_POSITIVE_BUTTON_PATH,
} from '../config/welcomeAssets';

const POSITIVE_EMOTE_TYPES = new Set([
  'Greet',
  'Thanks',
  'Good Game',
  'Well Played',
  'Wish Luck',
]);

const NEGATIVE_EMOTE_TYPES = new Set([
  'Taunt',
  'Wake Up',
]);

const NEUTRAL_EMOTE_TYPES = new Set([
  'Laugh',
  'Oops',
]);

/**
 * Maps unlock_catalog emote category names to painted button tone.
 */
export function getBattleEmoteButtonTone(emoteType) {
  if (typeof emoteType !== 'string' || !emoteType.trim()) {
    throw new Error('getBattleEmoteButtonTone: emoteType is required');
  }
  if (POSITIVE_EMOTE_TYPES.has(emoteType)) {
    return 'positive';
  }
  if (NEGATIVE_EMOTE_TYPES.has(emoteType)) {
    return 'negative';
  }
  if (NEUTRAL_EMOTE_TYPES.has(emoteType)) {
    return 'neutral';
  }
  throw new Error(`getBattleEmoteButtonTone: unknown emote category "${emoteType}"`);
}

/**
 * Painted button asset for a battle emote row by category tone.
 */
export function getBattleEmoteButtonPath(emoteType) {
  const tone = getBattleEmoteButtonTone(emoteType);
  if (tone === 'positive') {
    return BATTLE_UI_EMOTE_POSITIVE_BUTTON_PATH;
  }
  if (tone === 'negative') {
    return BATTLE_UI_EMOTE_NEGATIVE_BUTTON_PATH;
  }
  if (tone === 'neutral') {
    return BATTLE_UI_EMOTE_BUTTON_PATH;
  }
  throw new Error(`getBattleEmoteButtonPath: unsupported tone "${tone}"`);
}
